'use client';
import { Landscape_HeroSection } from '@/components/ui/catalog/landscape/CollectionOrDropHeroSection';
import { Landscape_Vision_Display } from '../landscape/LandscapeVisionDisplay';
import { Landscape_Description } from '@/components/ui/catalog/landscape/description';
import { Landscape_Display } from '../landscape/LandscapeDisplay';
import { Landscape_Immersive } from '../landscape/LandscapeImmersive';
import type {
  Nftcollection,
  LandscapeDisplay,
  LandscapeImmersive,
  LandscapeDescription,
  LandscapeChapterHero,
  LandscapeChapter,
  LandscapeProcess,
  LandscapeSketchbook,
  LandscapeVisionDisplay,
  VisionsSpecial,
} from '@/types';
import { Landscape_ChapterHero } from '../landscape/LandscapeChapterHero';
import { Landscape_Chapter } from '../landscape/LandscapeChapter';
import { Landscape_Process } from '../landscape/LandscapeProcess';
import { Landscape_Sketchbook } from '../landscape/LandscapeSketchbook';
import { Visions_Special } from '../landscape/VisionsSpecial';

export interface drop extends Nftcollection {
  tags?: string[];
  cats?: string[];
  isDrop?: boolean;
}

interface DropProps {
  detail: drop;
}

export default function DropDetailPage({ detail }: DropProps) {
  const GetLayout = ({
    layout,
  }: {
    layout:
      | LandscapeDisplay
      | LandscapeImmersive
      | LandscapeVisionDisplay
      | LandscapeDescription
      | LandscapeChapterHero
      | LandscapeChapter
      | LandscapeProcess
      | LandscapeSketchbook
      | VisionsSpecial;
  }) => {
    switch (layout.blockType) {
      case 'LandscapeDisplay':
        return <Landscape_Display layout={layout} />;
      case 'LandscapeImmersive':
        return <Landscape_Immersive layout={layout} />;
      case 'LandscapeVisionDisplay':
        return <Landscape_Vision_Display layout={layout} />;
      case 'LandscapeChapterHero':
        return <Landscape_ChapterHero layout={layout} />;
      case 'LandscapeChapter':
        return <Landscape_Chapter layout={layout} />;
      case 'LandscapeProcess':
        return <Landscape_Process layout={layout} />;
      case 'LandscapeSketchbook':
        return <Landscape_Sketchbook layout={layout} />;
      case 'VisionsSpecial':
        return <Visions_Special layout={layout} />;
      case 'LandscapeDescription':
        // specs
        const specs = [];
        if (detail.dropTypes && detail.dropTypes.length > 0) {
          specs.push({
            label: 'DROP TYPE',
            specifications: detail.dropTypes.map(dropType => ({
              value: typeof dropType === 'number' ? dropType.toString() : dropType.title,
            })),
          });
        }
        if (detail.collectionTypes && detail.collectionTypes.length > 0) {
          specs.push({
            label: 'ARTWORK TYPE',
            specifications: detail.collectionTypes.map(collectionType => ({
              value: typeof collectionType === 'number' ? collectionType.toString() : collectionType.title,
            })),
          });
        }
        if (detail.cats && detail.cats.length > 0) {
          specs.push({
            label: 'CATEGORIES',
            specifications: detail.cats.map(cat => ({ value: cat })),
          });
        }
        specs.push({
          label: 'EDITION',
          specifications: [
            { value: `${detail.totalSupply}/1/1`, light: true },
            // { value: 'PHYSICAL (20)' },
          ],
        });
        if (detail.requiredInformation?.blockchain) {
          specs.push({
            label: 'CHAIN',
            specifications: [{ value: detail.requiredInformation.blockchain.toUpperCase() }],
          });
        }
        if (detail.tokenStandard && typeof detail.tokenStandard !== 'number') {
          specs.push({
            label: 'Token',
            specifications: [{ value: detail.tokenStandard.title }],
          });
        }

        if (detail.requiredInformation?.contractAddress) {
          specs.push({
            label: 'SMART CONTRACT',
            specifications: [{ value: detail.requiredInformation.contractAddress, light: true }],
          });
        }
        if (detail.requiredInformation?.collectionInscriptionAddress) {
          specs.push({
            label: 'INSCRIPTION ADDRESS',
            specifications: [{ value: detail.requiredInformation.collectionInscriptionAddress, light: true }],
          });
        }

        if (detail.requiredInformation?.datamarket) {
          if (detail.marketUrl) {
            specs.push({
              label: 'platform',
              specifications: [{ value: detail.requiredInformation.datamarket, url: detail.marketUrl, light: true }],
            });
          } else {
            specs.push({
              label: 'platform',
              specifications: [{ value: detail.requiredInformation.datamarket, light: true }],
            });
          }
        }

        // additionalTags
        if (detail.additionalTags && detail.additionalTags.length > 0) {
          detail.additionalTags.map(tag => {
            specs.push({
              label: tag.title,
              specifications: tag.labels?.map(label => ({ value: label.title })),
            });
          });
        }
        return <Landscape_Description layout={layout} specs={specs} />;
      default:
        return null; // Eşleşme yoksa null döndür
    }
  };

  // Content area - ensure overflow works with parent container
  return (
    <div
      className="w-full bg-black relative h-full overflow-y-auto"
      style={{ scrollbarWidth: 'none' }}
      id="landscape-content"
    >
      {/* Hero Section */}
      <Landscape_HeroSection collection={detail} />

      {/* Landscape Sections */}
      {detail.layout.map((lay, index) => (
        <GetLayout key={index} layout={lay} />
      ))}
    </div>
  );
}
